module.exports = __webpack_public_path__ + "static/img/3.b599850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/premedical/3.png
// module id = lfz6
// module chunks = 1